import React from "react";

import Icon from "assets/BGC_Page1_Icon.svg";
import BGCInfoPage from "./BGCInfoPage";

const PageOne: React.FC = () => (
  <BGCInfoPage
    icon={Icon}
    iconAlt="BGC Science App icon"
    heading="What is the BGC Science App?"
  >
    The BGC Science App houses certain cognitive assessments for research
    purposes. Our research collaborators from Northeastern University develop
    these tests. We want to understand how they relate to your BrainHealth
    Index.
  </BGCInfoPage>
);

export default PageOne;
